export const toggleItemInArray = <T,>(array: T[], value: T): T[] => {
    if (array.includes(value)) {
        return array.filter((number) => number !== value);
    }

    return [...array, value];
};
